import React from 'react'
import { motion } from 'framer-motion'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { format } from 'date-fns'

ChartJS.register(ArcElement, Tooltip, Legend)

const ExchangeFeeResult = ({ result }) => {
  if (!result) return null

  const data = result;
  const formattedDate = format(new Date(data.timestamp), 'PPpp')

  const chartData = {
    labels: ['Maker Fee', 'Taker Fee'],
    datasets: [
      {
        label: 'Fees (USD)',
        data: [data.maker_fee_usd, data.taker_fee_usd],
        backgroundColor: ['#60a5fa', '#f87171'],
        borderColor: '#1f2937',
        borderWidth: 1,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#fff',
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: $${ctx.raw.toFixed(4)}`
        }
      }
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="rounded-2xl p-6 shadow-xl bg-slate-800/50 text-white backdrop-blur-lg border border-white/10"
    >
      <h2 className="text-2xl font-bold mb-4">Exchange Fee Result</h2>
      <p className="text-sm text-gray-300 mb-6">Data reflects the most recent update as of: {formattedDate}</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <InfoBlock label="Exchange" value={data.exchange} />
        <InfoBlock label="Symbol" value={data.symbol} />
        <InfoBlock label="Trade Volume (USD)" value={`$${data.volume_usd.toFixed(2)}`} />
        <InfoBlock label="Maker Fee" value={`$${data.maker_fee_usd.toFixed(4)}`} />
        <InfoBlock label="Taker Fee" value={`$${data.taker_fee_usd.toFixed(4)}`} />
      </div>

      <div className="max-w-xs mx-auto mt-4">
        <Pie data={chartData} options={chartOptions} />
      </div>

      <p className="text-xs text-gray-300 mt-6">This is tentative data and may not reflect precise values.</p>
    </motion.div>
  )
}

const InfoBlock = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-400">{label}</p>
    <p className="font-semibold capitalize" >{value}</p>
  </div>
)

export default ExchangeFeeResult
